import { useEffect } from 'react';
import { createContext, useState } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({children}) => { 
	const [auth, setAuth] 	= useState({});

	// Adiciona evento para monitorar logout em outras abas
	useEffect(() => {
		const onStorage = (event) => {
			if (event.key === 'logout') {
				setAuth({})
			}
		};

		window.addEventListener('storage', onStorage);
		return () => window.removeEventListener('storage', onStorage);
	}, [])

	return ( 
		<AuthContext.Provider value={{ auth, setAuth }}>
			{children}
		</AuthContext.Provider>
	)
}

export default AuthContext;